import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/shared/base-service/base-service.service';
import { Cliente } from '../interfaces/cliente';
import { SelectConfig } from 'src/app/shared/components/form-control/form-control.component';
import { Pendencia } from '../../pendencias/interfaces/pendencia';

@Injectable({
  providedIn: 'root'
})
export class ClienteService extends BaseService<Cliente> {

  constructor(protected http: HttpClient) {
    super(http, 'clientes');
  }

  selectConfig: SelectConfig = {
    label: 'nome_fantasia',
    value: 'id',
    optionDetails: [
      { prop: 'codigo' },
      { prop: 'cnpj', pipe: 'cpfCnpjMask' }
    ],
    clearable: true,
    searchable: true,
    fnSearch: (term: string, item: Cliente) => {
      term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");
      return (item.nome_fantasia && item.nome_fantasia.toLocaleLowerCase().includes(term)) ||
        (item.razao_social && item.razao_social.toLocaleLowerCase().replace(/[/\.-]/g, "").includes(term)) ||
        (item.cnpj && item.cnpj.toLocaleLowerCase().replace(/[/\.-]/g, "").includes(term)) ||
        (item.codigo && item.codigo.toLocaleLowerCase().replace(/[/\.-]/g, "").includes(term));
    }
  };

  getByCodigo(codigo: string) {
    return this.http.get<Cliente>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/codigo/${codigo}`);
  }

  getByPrestador(prestadorId: number) {
    return this.http.get<Cliente[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/prestador/${prestadorId}`);
  }

  getComIntegracao() {
    return this.http.get<Cliente[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/integracao`);
  }

  getPendencias(id: number) {
    return this.http.get<Pendencia[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}/pendencias`);
  }
}